import { StyleSheet, Text, View } from '@react-pdf/renderer'
import { Severity } from './severity'

export const Severities = () => (
    <View style={styles.severitiesContainer}>
        <Text style={styles.title}>HOW SERIOUS IS THE ISSUE?</Text>
        <View style={styles.severities}>
            <Severity
                severity="critical"
                description="Critical issues must be resolved to bind your policy."
            />
            <Severity
                severity="important"
                description="Important issues may impact your premium or coverage."
            />
            <Severity
                severity="moderate"
                description="Moderate issues should be resolved to improve business security."
            />
        </View>
    </View>
)

const styles = StyleSheet.create({
    severitiesContainer: {
        fontSize: 6.75,
    },
    title: {
        fontWeight: 'bold',
    },
    severities: {
        marginTop: 10,
    },
})
